import { responsiveFontSizes } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles'
import typography from './typography';
import palette from './palette';
import overrides from './overrides';

const theme = createTheme({
	palette,
	typography,
	overrides,
});

export default responsiveFontSizes(theme);
